import DiscoTableSortDropdown, {
  DiscoTableSortDirection,
  DiscoTableSortOption,
  DiscoTableToolbarStateWithSort,
} from "@disco-ui/table/header/search/DiscoTableSortDropdown"
import { TestIDProps } from "@utils/typeUtils"

type MemberSortDropdownOption = "member_name" | "recently_active" | "joined_on" | "role"

export interface MembersSortDropdownProps extends TestIDProps {
  sortState: DiscoTableToolbarStateWithSort
  setSortState: (state: DiscoTableToolbarStateWithSort) => void
  buttonVariant?: "default" | "icon"
  options: MemberSortDropdownOption[]
}

function MembersSortDropdown({
  sortState,
  setSortState,
  buttonVariant,
  options,
}: MembersSortDropdownProps) {
  const SORT_OPTIONS: Record<MemberSortDropdownOption, DiscoTableSortOption> = {
    member_name: {
      value: "member name",
      title: "Name",
      context: {
        order: { field: "member_name" },
      },
    },
    recently_active: {
      value: "last active",
      title: "Last Active",
      context: {
        order: { field: "recently_active" },
      },
    },
    joined_on: {
      value: "join date",
      title: "Join Date",
      context: {
        order: { field: "joined_on" },
      },
    },
    role: {
      value: "role",
      title: "Role",
      context: {
        order: { field: "role" },
      },
    },
  }

  return (
    <DiscoTableSortDropdown
      testid={"MembersSortDropdown"}
      options={options.map((o) => SORT_OPTIONS[o])}
      onOptionSelect={handleSortSelect}
      toolbarState={sortState}
      variant={buttonVariant}
    />
  )

  function handleSortSelect(
    sortOption: DiscoTableSortOption,
    direction: DiscoTableSortDirection
  ) {
    setSortState({
      search: sortState.search,
      sort: {
        id: sortOption.value,
        order: sortOption.context!.order,
        title: sortOption.title,
      },
      direction,
    })
  }
}

export default MembersSortDropdown
